export const bookAnimated = (isDarkMode: boolean) => ({
    nm: 'Main Scene',
    ddd: 0,
    h: 500,
    w: 500,
    meta: {
        g: '@lottiefiles/creator 1.44.0'
    },
    layers: [
        {
            ty: 4,
            nm: 'book Outlines - Group 7',
            sr: 1,
            st: 45,
            op: 89,
            ip: 45,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        29.69,
                        21.555,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        700,
                        700,
                        100
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        294.491,
                        234.977,
                        0
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 2',
                    ix: 1,
                    cix: 2,
                    np: 3,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 1,
                                k: [
                                    {
                                        o: {
                                            x: 0.333,
                                            y: 0
                                        },
                                        i: {
                                            x: 0.667,
                                            y: 1
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        0.001,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        0.365,
                                                        -7.827
                                                    ],
                                                    [
                                                        6.355,
                                                        -7.827
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 45
                                    },
                                    {
                                        o: {
                                            x: 0.333,
                                            y: 0
                                        },
                                        i: {
                                            x: 0.667,
                                            y: 1
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        2.295,
                                                        0.016
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -2.739,
                                                        -0.035
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -2.134,
                                                        -0.015
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        1.904,
                                                        0.025
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        0.424,
                                                        7.816
                                                    ],
                                                    [
                                                        -3.007,
                                                        6.554
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        -2.76,
                                                        -9.104
                                                    ],
                                                    [
                                                        0.407,
                                                        -7.831
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 53
                                    },
                                    {
                                        o: {
                                            x: 0.333,
                                            y: 0
                                        },
                                        i: {
                                            x: 0.667,
                                            y: 1
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.969,
                                                        -0.837
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        1.021,
                                                        0.945
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        1.256,
                                                        1.085
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.942,
                                                        -0.872
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -10.178,
                                                        4.295
                                                    ],
                                                    [
                                                        -8.379,
                                                        6.418
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        -8.163,
                                                        -8.941
                                                    ],
                                                    [
                                                        -10.253,
                                                        -11.427
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 59
                                    },
                                    {
                                        o: {
                                            x: 0.333,
                                            y: 0
                                        },
                                        i: {
                                            x: 0.667,
                                            y: 1
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -1.686,
                                                        -0.543
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        2.632,
                                                        0.689
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        2.135,
                                                        0.688
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.745,
                                                        -0.195
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -13.708,
                                                        5.688
                                                    ],
                                                    [
                                                        -10.17,
                                                        6.975
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        -10.095,
                                                        -8.507
                                                    ],
                                                    [
                                                        -13.781,
                                                        -9.993
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 61
                                    },
                                    {
                                        o: {
                                            x: 0.333,
                                            y: 0
                                        },
                                        i: {
                                            x: 0.667,
                                            y: 1
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -19.002,
                                                        7.777
                                                    ],
                                                    [
                                                        -12.857,
                                                        7.811
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        -12.993,
                                                        -7.856
                                                    ],
                                                    [
                                                        -19.073,
                                                        -7.843
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 68
                                    },
                                    {
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -19.002,
                                                        7.777
                                                    ],
                                                    [
                                                        -12.857,
                                                        7.811
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        -12.993,
                                                        -7.856
                                                    ],
                                                    [
                                                        -19.073,
                                                        -7.843
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 91
                                    }
                                ],
                                ix: 2
                            }
                        },
                        {
                            ty: 'st',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Stroke',
                            nm: 'Stroke 1',
                            lc: 2,
                            lj: 2,
                            ml: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 4
                            },
                            w: {
                                a: 0,
                                k: 1,
                                ix: 5
                            },
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 3
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [1, 1, 1] : [0, 0.0314, 0.2235],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    29.69,
                                    21.555
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 1
        },
        {
            ty: 4,
            nm: 'book Outlines - Group 6',
            sr: 1,
            st: 28,
            op: 75,
            ip: 28,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        29.69,
                        21.555,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        700,
                        700,
                        100
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        294.491,
                        234.977,
                        0
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 2',
                    ix: 1,
                    cix: 2,
                    np: 3,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 1,
                                k: [
                                    {
                                        o: {
                                            x: 0.333,
                                            y: 0
                                        },
                                        i: {
                                            x: 0.667,
                                            y: 1
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        0.001,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        0.365,
                                                        -7.827
                                                    ],
                                                    [
                                                        6.355,
                                                        -7.827
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 28
                                    },
                                    {
                                        o: {
                                            x: 0.333,
                                            y: 0
                                        },
                                        i: {
                                            x: 0.667,
                                            y: 1
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        2.295,
                                                        0.016
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -2.739,
                                                        -0.035
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -2.134,
                                                        -0.015
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        1.904,
                                                        0.025
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        0.424,
                                                        7.816
                                                    ],
                                                    [
                                                        -3.007,
                                                        6.554
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        -2.76,
                                                        -9.104
                                                    ],
                                                    [
                                                        0.407,
                                                        -7.831
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 36
                                    },
                                    {
                                        o: {
                                            x: 0.333,
                                            y: 0
                                        },
                                        i: {
                                            x: 0.667,
                                            y: 1
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.969,
                                                        -0.837
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        1.021,
                                                        0.945
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        1.256,
                                                        1.085
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.942,
                                                        -0.872
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -10.178,
                                                        4.295
                                                    ],
                                                    [
                                                        -8.379,
                                                        6.418
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        -8.163,
                                                        -8.941
                                                    ],
                                                    [
                                                        -10.253,
                                                        -11.427
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 42
                                    },
                                    {
                                        o: {
                                            x: 0.333,
                                            y: 0
                                        },
                                        i: {
                                            x: 0.667,
                                            y: 1
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -1.686,
                                                        -0.543
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        2.632,
                                                        0.689
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        2.135,
                                                        0.688
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.745,
                                                        -0.195
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -13.708,
                                                        5.688
                                                    ],
                                                    [
                                                        -10.17,
                                                        6.975
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        -10.095,
                                                        -8.507
                                                    ],
                                                    [
                                                        -13.781,
                                                        -9.993
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 44
                                    },
                                    {
                                        o: {
                                            x: 0.333,
                                            y: 0
                                        },
                                        i: {
                                            x: 0.667,
                                            y: 1
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -19.002,
                                                        7.777
                                                    ],
                                                    [
                                                        -12.857,
                                                        7.811
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        -12.993,
                                                        -7.856
                                                    ],
                                                    [
                                                        -19.073,
                                                        -7.843
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 51
                                    },
                                    {
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -19.002,
                                                        7.777
                                                    ],
                                                    [
                                                        -12.857,
                                                        7.811
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        -12.993,
                                                        -7.856
                                                    ],
                                                    [
                                                        -19.073,
                                                        -7.843
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 75
                                    }
                                ],
                                ix: 2
                            }
                        },
                        {
                            ty: 'st',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Stroke',
                            nm: 'Stroke 1',
                            lc: 2,
                            lj: 2,
                            ml: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 4
                            },
                            w: {
                                a: 0,
                                k: 1,
                                ix: 5
                            },
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 3
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [1, 1, 1] : [0, 0.0314, 0.2235],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    29.69,
                                    21.555
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 2
        },
        {
            ty: 4,
            nm: 'book Outlines - Group 5',
            sr: 1,
            st: 14,
            op: 52,
            ip: 14,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        29.69,
                        21.555,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        700,
                        700,
                        100
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        294.491,
                        234.977,
                        0
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 2',
                    ix: 1,
                    cix: 2,
                    np: 3,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 1,
                                k: [
                                    {
                                        o: {
                                            x: 0.167,
                                            y: 0.167
                                        },
                                        i: {
                                            x: 0.833,
                                            y: 0.833
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        0.001,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        0.365,
                                                        -7.827
                                                    ],
                                                    [
                                                        6.355,
                                                        -7.827
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 14
                                    },
                                    {
                                        o: {
                                            x: 0.167,
                                            y: 0.167
                                        },
                                        i: {
                                            x: 0.833,
                                            y: 0.833
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        2.295,
                                                        0.016
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -2.739,
                                                        -0.035
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -2.134,
                                                        -0.015
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        1.904,
                                                        0.025
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        0.424,
                                                        7.816
                                                    ],
                                                    [
                                                        -3.007,
                                                        6.554
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        -2.76,
                                                        -9.104
                                                    ],
                                                    [
                                                        0.407,
                                                        -7.831
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 22
                                    },
                                    {
                                        o: {
                                            x: 0.167,
                                            y: 0.167
                                        },
                                        i: {
                                            x: 0.833,
                                            y: 0.833
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.969,
                                                        -0.837
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        1.021,
                                                        0.945
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        1.256,
                                                        1.085
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.942,
                                                        -0.872
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -10.178,
                                                        4.295
                                                    ],
                                                    [
                                                        -8.379,
                                                        6.418
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        -8.163,
                                                        -8.941
                                                    ],
                                                    [
                                                        -10.253,
                                                        -11.427
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 28
                                    },
                                    {
                                        o: {
                                            x: 0.167,
                                            y: 0.167
                                        },
                                        i: {
                                            x: 0.833,
                                            y: 0.833
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -1.686,
                                                        -0.543
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        2.632,
                                                        0.689
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        2.135,
                                                        0.688
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.745,
                                                        -0.195
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -13.708,
                                                        5.688
                                                    ],
                                                    [
                                                        -10.17,
                                                        6.975
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        -10.095,
                                                        -8.507
                                                    ],
                                                    [
                                                        -13.781,
                                                        -9.993
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 30
                                    },
                                    {
                                        o: {
                                            x: 0.167,
                                            y: 0.167
                                        },
                                        i: {
                                            x: 0.833,
                                            y: 0.833
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -19.002,
                                                        7.777
                                                    ],
                                                    [
                                                        -12.857,
                                                        7.811
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        -12.993,
                                                        -7.856
                                                    ],
                                                    [
                                                        -19.073,
                                                        -7.843
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 37
                                    },
                                    {
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -19.002,
                                                        7.777
                                                    ],
                                                    [
                                                        -12.857,
                                                        7.811
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        -12.993,
                                                        -7.856
                                                    ],
                                                    [
                                                        -19.073,
                                                        -7.843
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 75
                                    }
                                ],
                                ix: 2
                            }
                        },
                        {
                            ty: 'st',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Stroke',
                            nm: 'Stroke 1',
                            lc: 2,
                            lj: 2,
                            ml: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 4
                            },
                            w: {
                                a: 0,
                                k: 1,
                                ix: 5
                            },
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 3
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [1, 1, 1] : [0, 0.0314, 0.2235],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    29.69,
                                    21.555
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 3
        },
        {
            ty: 4,
            nm: 'book Outlines - Group 4',
            sr: 1,
            st: 0,
            op: 31,
            ip: 0,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        29.690000000000005,
                        21.57704990386962
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        700,
                        700,
                        100
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        294.491,
                        235.13134932708735
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 2',
                    ix: 1,
                    cix: 2,
                    np: 3,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 1,
                                k: [
                                    {
                                        o: {
                                            x: 0.167,
                                            y: 0.167
                                        },
                                        i: {
                                            x: 0.667,
                                            y: 1
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        0.001,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        0.365,
                                                        -7.827
                                                    ],
                                                    [
                                                        6.355,
                                                        -7.827
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 0
                                    },
                                    {
                                        o: {
                                            x: 0.333,
                                            y: 0
                                        },
                                        i: {
                                            x: 0.667,
                                            y: 1
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        2.295,
                                                        0.016
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -2.739,
                                                        -0.035
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -2.134,
                                                        -0.015
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        1.904,
                                                        0.025
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        0.424,
                                                        7.816
                                                    ],
                                                    [
                                                        -3.007,
                                                        6.554
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        -2.76,
                                                        -9.104
                                                    ],
                                                    [
                                                        0.407,
                                                        -7.831
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 8
                                    },
                                    {
                                        o: {
                                            x: 0.333,
                                            y: 0
                                        },
                                        i: {
                                            x: 0.667,
                                            y: 1
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.969,
                                                        -0.837
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        1.021,
                                                        0.945
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        1.256,
                                                        1.085
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.942,
                                                        -0.872
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -10.178,
                                                        4.295
                                                    ],
                                                    [
                                                        -8.379,
                                                        6.418
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        -8.163,
                                                        -8.941
                                                    ],
                                                    [
                                                        -10.253,
                                                        -11.427
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 14
                                    },
                                    {
                                        o: {
                                            x: 0.333,
                                            y: 0
                                        },
                                        i: {
                                            x: 0.667,
                                            y: 1
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -1.686,
                                                        -0.543
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        2.632,
                                                        0.689
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        2.135,
                                                        0.688
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.745,
                                                        -0.195
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -13.708,
                                                        5.688
                                                    ],
                                                    [
                                                        -10.17,
                                                        6.975
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        -10.095,
                                                        -8.507
                                                    ],
                                                    [
                                                        -13.781,
                                                        -9.993
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 16
                                    },
                                    {
                                        o: {
                                            x: 0.333,
                                            y: 0
                                        },
                                        i: {
                                            x: 0.667,
                                            y: 1
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -19.002,
                                                        7.777
                                                    ],
                                                    [
                                                        -12.857,
                                                        7.811
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        -12.993,
                                                        -7.856
                                                    ],
                                                    [
                                                        -19.073,
                                                        -7.843
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 23
                                    },
                                    {
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -19.002,
                                                        7.777
                                                    ],
                                                    [
                                                        -12.857,
                                                        7.811
                                                    ],
                                                    [
                                                        -6.355,
                                                        7.827
                                                    ],
                                                    [
                                                        -6.355,
                                                        -7.827
                                                    ],
                                                    [
                                                        -12.993,
                                                        -7.856
                                                    ],
                                                    [
                                                        -19.073,
                                                        -7.843
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 75
                                    }
                                ],
                                ix: 2
                            }
                        },
                        {
                            ty: 'st',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Stroke',
                            nm: 'Stroke 1',
                            lc: 2,
                            lj: 2,
                            ml: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 4
                            },
                            w: {
                                a: 0,
                                k: 1,
                                ix: 5
                            },
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 3
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [1, 1, 1] : [0, 0.0314, 0.2235],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    29.69,
                                    21.555
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 4
        },
        {
            ty: 4,
            nm: 'book Outlines - Group 2',
            sr: 1,
            st: 0,
            op: 90,
            ip: 0,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        29.69,
                        21.555,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        700,
                        700,
                        100
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        294.491,
                        234.977,
                        0
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 2',
                    ix: 1,
                    cix: 2,
                    np: 3,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            6.355,
                                            7.827
                                        ],
                                        [
                                            0.001,
                                            7.827
                                        ],
                                        [
                                            -6.355,
                                            7.827
                                        ],
                                        [
                                            -6.355,
                                            -7.827
                                        ],
                                        [
                                            0.365,
                                            -7.827
                                        ],
                                        [
                                            6.355,
                                            -7.827
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'st',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Stroke',
                            nm: 'Stroke 1',
                            lc: 1,
                            lj: 1,
                            ml: 10,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 4
                            },
                            w: {
                                a: 0,
                                k: 1,
                                ix: 5
                            },
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 3
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [1, 1, 1] : [0, 0.0314, 0.2235],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    29.69,
                                    21.555
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 5
        },
        {
            ty: 4,
            nm: 'book Outlines - Group 3',
            sr: 1,
            st: 0,
            op: 90,
            ip: 0,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        16.979,
                        21.556,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        700,
                        700,
                        100
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        205.514,
                        234.979,
                        0
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 3',
                    ix: 1,
                    cix: 2,
                    np: 3,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            6.355,
                                            7.827
                                        ],
                                        [
                                            -6.355,
                                            7.827
                                        ],
                                        [
                                            -6.355,
                                            -7.827
                                        ],
                                        [
                                            6.355,
                                            -7.827
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'st',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Stroke',
                            nm: 'Stroke 1',
                            lc: 1,
                            lj: 1,
                            ml: 10,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 4
                            },
                            w: {
                                a: 0,
                                k: 1,
                                ix: 5
                            },
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 3
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [1, 1, 1] : [0, 0.0314, 0.2235],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    16.979,
                                    21.556
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 6
        },
        {
            ty: 4,
            nm: 'Book',
            sr: 1,
            st: 0,
            op: 90,
            ip: 0,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        250,
                        299.42,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        100,
                        100,
                        100
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        250,
                        299.42,
                        0
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'book Outlines - Group 1',
                    ix: 1,
                    cix: 2,
                    np: 1,
                    it: [
                        {
                            ty: 'gr',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Group',
                            nm: 'Group 1',
                            ix: 1,
                            cix: 2,
                            np: 2,
                            it: [
                                {
                                    ty: 'sh',
                                    bm: 0,
                                    hd: false,
                                    mn: 'ADBE Vector Shape - Group',
                                    nm: 'Path 1',
                                    ix: 1,
                                    d: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            c: true,
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    1.314,
                                                    2.146
                                                ],
                                                [
                                                    -1.314,
                                                    2.146
                                                ],
                                                [
                                                    -1.314,
                                                    -2.146
                                                ],
                                                [
                                                    1.314,
                                                    -2.146
                                                ]
                                            ]
                                        },
                                        ix: 2
                                    }
                                },
                                {
                                    ty: 'st',
                                    bm: 0,
                                    hd: false,
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    nm: 'Stroke 1',
                                    lc: 1,
                                    lj: 1,
                                    ml: 10,
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 4
                                    },
                                    w: {
                                        a: 0,
                                        k: 1,
                                        ix: 5
                                    },
                                    c: {
                                        a: 0,
                                        k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                        ix: 3
                                    }
                                },
                                {
                                    ty: 'tr',
                                    a: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 1
                                    },
                                    s: {
                                        a: 0,
                                        k: [
                                            100,
                                            100
                                        ],
                                        ix: 3
                                    },
                                    sk: {
                                        a: 0,
                                        k: 0,
                                        ix: 4
                                    },
                                    p: {
                                        a: 0,
                                        k: [
                                            16.134,
                                            31.529
                                        ],
                                        ix: 2
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                        ix: 6
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                        ix: 5
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 7
                                    }
                                }
                            ]
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    16.134,
                                    31.529
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    700,
                                    700
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    199.599,
                                    304.793
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'book Outlines - Group 4',
                    ix: 2,
                    cix: 2,
                    np: 1,
                    it: [
                        {
                            ty: 'gr',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Group',
                            nm: 'Group 4',
                            ix: 1,
                            cix: 2,
                            np: 2,
                            it: [
                                {
                                    ty: 'sh',
                                    bm: 0,
                                    hd: false,
                                    mn: 'ADBE Vector Shape - Group',
                                    nm: 'Path 1',
                                    ix: 1,
                                    d: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            c: false,
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.512,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.8
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.513
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.8,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    6.355,
                                                    -2.327
                                                ],
                                                [
                                                    6.355,
                                                    -0.411
                                                ],
                                                [
                                                    3.617,
                                                    2.327
                                                ],
                                                [
                                                    -4.907,
                                                    2.327
                                                ],
                                                [
                                                    -6.355,
                                                    0.879
                                                ],
                                                [
                                                    -6.355,
                                                    -2.327
                                                ]
                                            ]
                                        },
                                        ix: 2
                                    }
                                },
                                {
                                    ty: 'st',
                                    bm: 0,
                                    hd: false,
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    nm: 'Stroke 1',
                                    lc: 1,
                                    lj: 1,
                                    ml: 10,
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 4
                                    },
                                    w: {
                                        a: 0,
                                        k: 1,
                                        ix: 5
                                    },
                                    c: {
                                        a: 0,
                                        k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                        ix: 3
                                    }
                                },
                                {
                                    ty: 'tr',
                                    a: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 1
                                    },
                                    s: {
                                        a: 0,
                                        k: [
                                            100,
                                            100
                                        ],
                                        ix: 3
                                    },
                                    sk: {
                                        a: 0,
                                        k: 0,
                                        ix: 4
                                    },
                                    p: {
                                        a: 0,
                                        k: [
                                            29.69,
                                            30.175
                                        ],
                                        ix: 2
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                        ix: 6
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                        ix: 5
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 7
                                    }
                                }
                            ]
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    29.69,
                                    30.175
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    700,
                                    700
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    294.491,
                                    295.313
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'book Outlines - Group 5',
                    ix: 3,
                    cix: 2,
                    np: 1,
                    it: [
                        {
                            ty: 'gr',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Group',
                            nm: 'Group 5',
                            ix: 1,
                            cix: 2,
                            np: 2,
                            it: [
                                {
                                    ty: 'sh',
                                    bm: 0,
                                    hd: false,
                                    mn: 'ADBE Vector Shape - Group',
                                    nm: 'Path 1',
                                    ix: 1,
                                    d: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            c: false,
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.801,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.8
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    2.943,
                                                    -1.827
                                                ],
                                                [
                                                    2.943,
                                                    0.379
                                                ],
                                                [
                                                    1.494,
                                                    1.827
                                                ],
                                                [
                                                    -2.943,
                                                    1.827
                                                ]
                                            ]
                                        },
                                        ix: 2
                                    }
                                },
                                {
                                    ty: 'st',
                                    bm: 0,
                                    hd: false,
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    nm: 'Stroke 1',
                                    lc: 1,
                                    lj: 1,
                                    ml: 10,
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 4
                                    },
                                    w: {
                                        a: 0,
                                        k: 1,
                                        ix: 5
                                    },
                                    c: {
                                        a: 0,
                                        k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                        ix: 3
                                    }
                                },
                                {
                                    ty: 'tr',
                                    a: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 1
                                    },
                                    s: {
                                        a: 0,
                                        k: [
                                            100,
                                            100
                                        ],
                                        ix: 3
                                    },
                                    sk: {
                                        a: 0,
                                        k: 0,
                                        ix: 4
                                    },
                                    p: {
                                        a: 0,
                                        k: [
                                            20.392,
                                            30.675
                                        ],
                                        ix: 2
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                        ix: 6
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                        ix: 5
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 7
                                    }
                                }
                            ]
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    20.392,
                                    30.675
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    700,
                                    700
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    229.402,
                                    298.813
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'book Outlines - Group 6',
                    ix: 4,
                    cix: 2,
                    np: 1,
                    it: [
                        {
                            ty: 'gr',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Group',
                            nm: 'Group 6',
                            ix: 1,
                            cix: 2,
                            np: 2,
                            it: [
                                {
                                    ty: 'sh',
                                    bm: 0,
                                    hd: false,
                                    mn: 'ADBE Vector Shape - Group',
                                    nm: 'Path 1',
                                    ix: 1,
                                    d: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            c: false,
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.512
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.512,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    2.098,
                                                    1.827
                                                ],
                                                [
                                                    0.641,
                                                    1.827
                                                ],
                                                [
                                                    -2.098,
                                                    -0.911
                                                ],
                                                [
                                                    -2.098,
                                                    -1.827
                                                ]
                                            ]
                                        },
                                        ix: 2
                                    }
                                },
                                {
                                    ty: 'st',
                                    bm: 0,
                                    hd: false,
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    nm: 'Stroke 1',
                                    lc: 1,
                                    lj: 1,
                                    ml: 10,
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 4
                                    },
                                    w: {
                                        a: 0,
                                        k: 1,
                                        ix: 5
                                    },
                                    c: {
                                        a: 0,
                                        k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                        ix: 3
                                    }
                                },
                                {
                                    ty: 'tr',
                                    a: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 1
                                    },
                                    s: {
                                        a: 0,
                                        k: [
                                            100,
                                            100
                                        ],
                                        ix: 3
                                    },
                                    sk: {
                                        a: 0,
                                        k: 0,
                                        ix: 4
                                    },
                                    p: {
                                        a: 0,
                                        k: [
                                            12.722,
                                            30.675
                                        ],
                                        ix: 2
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                        ix: 6
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                        ix: 5
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 7
                                    }
                                }
                            ]
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    12.722,
                                    30.675
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    700,
                                    700
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    175.71,
                                    298.815
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 7
        }
    ],
    v: '5.7.0',
    fr: 60,
    op: 89,
    ip: 0,
    assets: []
});
